import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';

import { Dialog } from 'primeng/dialog';
import { Divider } from 'primeng/divider';
import { Subject, EMPTY } from 'rxjs';
import { catchError, finalize, takeUntil } from 'rxjs/operators';
import { CadObject } from '../../../../../../models/cad-object.model';
import { CadFileService } from '../../../../../services/cad-file.service';
import { CadViewerComponent } from '../../../../../cad-viewer/cad-viewer.component';
import { CadObjectTreeComponent } from '../../../../../shared/cad-object-tree/cad-object-tree.component';
import { CadPropertiesComponent } from '../../../../../shared/cad-properties/cad-properties.component';

@Component({
  selector: 'app-quote-item-linked-cad-modal',
  imports: [
    Dialog,
    Divider,
    CadViewerComponent,
    CadObjectTreeComponent,
    CadPropertiesComponent,
  ],
  templateUrl: './quote-item-linked-cad-modal.component.html',
  styleUrl: './quote-item-linked-cad-modal.component.scss',
})
export class QuoteItemLinkedCadModalComponent implements OnChanges, OnDestroy {
  @Input() visible = false;
  @Input() itemName = '';
  @Input() cadObjectIds: number[] = [];

  @Output() closed = new EventEmitter<void>();

  loading = false;
  dialogVisible = false;
  selectedCadObject: CadObject | null = null;
  hoveredCadObjectId: number | null = null;
  visibleCadObjectIds: Set<number> | null = null;
  loadedCadObjects: CadObject[] = [];

  private readonly destroy$ = new Subject<void>();

  private readonly cadFileService = inject(CadFileService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']) {
      this.dialogVisible = this.visible;
    }

    if (!this.visible) {
      return;
    }

    if (changes['visible'] || changes['cadObjectIds']) {
      this.loadCadObjects();
    }
  }

  onDialogShow(): void {
    window.dispatchEvent(new Event('resize'));
  }

  onDialogHide(): void {
    this.dialogVisible = false;
    this.loading = false;
    this.selectedCadObject = null;
    this.loadedCadObjects = [];
    this.closed.emit();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSelectedCadObjectChange(cadObject: CadObject | null): void {
    this.selectedCadObject = cadObject;
  }

  private loadCadObjects(): void {
    if (!this.cadObjectIds.length) {
      this.selectedCadObject = null;
      this.loadedCadObjects = [];
      return;
    }

    this.loading = true;

    this.cadFileService
      .loadCadObjects(this.cadObjectIds)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        }),
        catchError((err) => {
          console.error('Error loading linked CAD objects', err);
          return EMPTY;
        }),
      )
      .subscribe((loadedObjects) => {
        this.loadedCadObjects = loadedObjects;
        this.selectedCadObject = loadedObjects[0] ?? null;
      });
  }
}
